import { addDoc, collection, deleteDoc, doc, DocumentData, getDoc, getDocs, getFirestore, Query, query, serverTimestamp, setDoc, updateDoc, where } from "firebase/firestore";
import { deleteObject, getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

export class FirestoreService {

    static async getCollectionForUserId<T>(path: string, userId: string, errorCallback: (error) => void, includeArchived?: boolean) {
        const db = getFirestore();
        const dbCol = collection(db, path);
        let q: Query<DocumentData>;
        if(includeArchived){
            q = query(dbCol, where("userId", "==", userId));
        }else {
            q = query(dbCol, where("userId", "==", userId), where("archived", "==", false));
        }

        try {
            const dbSnapshot = await getDocs(q);
            const list = dbSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }) as any);
            return list as T[];
        } catch (e) {
            errorCallback(e);
        }
    }


    static async getCollection<T>(path: string, errorCallback: (error) => void) {
        const db = getFirestore();
        const dbCol = collection(db, path);
        try {
            const dbSnapshot = await getDocs(dbCol);
            const list = dbSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }) as any);
            return list as T[];
        } catch (e) {
            errorCallback(e);
        }
    }

    static async addDoc<T>(path: string, docData: T, errorCallback: (error) => void) {
        (docData as any).lastEdit = serverTimestamp();
        (docData as any).archived = false;
        const db = getFirestore();
        const collectionRef = collection(db, path);
        try {
            const docRef = await addDoc(collectionRef, docData);
            return docRef;
        } catch (e) {
            errorCallback(e);
        }
    }

    static async addDocWithId<T>(path: string, docData: T, errorCallback: (error) => void) {
        (docData as any).lastEdit = serverTimestamp();
        (docData as any).archived = false;
        const db = getFirestore();
        const docRef = doc(db, path);
        try {
            return await setDoc(docRef, docData);
        } catch (e) {
            errorCallback(e);
        }
    }


    static async editDoc<T>(path: string, docData: T, id: string, errorCallback: (error) => void) {
        (docData as any).lastEdit = serverTimestamp();
        const db = getFirestore();
        const docRef = doc(db, path, id);
        try {
            await updateDoc(docRef, docData as any);
            return docRef;
        } catch (e) {
            errorCallback(e);
        }
    }

    static async setDoc<T>(path: string, docData: T, id: string, errorCallback: (error) => void) {
        (docData as any).lastEdit = serverTimestamp();
        const db = getFirestore();
        const docRef = doc(db, path, id);
        try {
            await setDoc(docRef, docData);
            return docRef;
        } catch (e) {
            errorCallback(e);
        }
    }
    
    static async archiveDoc(path: string, id: string, errorCallback: (error) => void) {
        const docData = { archived: true, lastEdit: serverTimestamp() };
        const db = getFirestore();
        const docRef = doc(db, path, id);
        try {
            await updateDoc(docRef, docData);
            return docRef;
        } catch (e) {
            errorCallback(e);
        }
    }

    static async getDoc(path: string, id: string, errorCallback: (error) => void) {
        const db = getFirestore();
        const docRef = doc(db, path, id);
        try {
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                return docSnap.data() as any;
            } else {
                // doc.data() will be undefined in this case
                errorCallback({ message: 'Document bestaat niet' })
            }
        } catch (e) {
            errorCallback(e);
        }
    }

    static async deleteDoc(path: string, id: string, errorCallback: (error) => void) {
        const db = getFirestore();
        const docRef = doc(db, path, id);
        await deleteDoc(docRef);
        return docRef;
    }

    static async uploadFile(path: string, file: File, metadata) {
        const storage = getStorage();
        const storageRef = ref(storage, path);
        return uploadBytes(storageRef, file, metadata);
    }

    static async getDownloadUrl(path: string) {
        const storage = getStorage();
        const pathReference = ref(storage, path);
        const downloadUrl = await getDownloadURL(pathReference);
        return downloadUrl;
    }

    static async deleteFileOrFolder(path: string) {
        const storage = getStorage();
        const desertRef = ref(storage, path);
        return deleteObject(desertRef);
    }
}